import { Component, OnInit } from '@angular/core';
import { MainMapService } from '../../shared/service/main-map.service';
import { EsriExtent } from '../../config/esri.module';
import { ConfigService } from '../../config/config.service';
import { WidgetService } from '../../shared/service/widget.service';
import { UserService } from '../../core/service/user.service';
import { User } from '../../core/model/user.model';
import { Router } from '@angular/router';
import { WidgetNotifyService } from '../../shared/service/widget-notify.service';
import { CONSTANTS_VALUE } from '../../config/constants.module';
import { ToggleSidebarService } from '../../shared/service/toggle-sidebar.service';

@Component({
    selector: 'header-panel',
    templateUrl: 'header-panel.component.html',
    styleUrls: ['header-panel.component.scss'],
    standalone: false
})
export class HeaderPanelComponent implements OnInit {
  public user: User;
  public mapViewReady = false;

  constructor(
    public router: Router,
    private _mainMapService: MainMapService,
    private _configService: ConfigService,
    private _userService: UserService,
    private _widgetService: WidgetService,
    private _widgetNotifyService: WidgetNotifyService,
    private toggleSidebarService: ToggleSidebarService
  ) {
    this.user = this._userService.user;
  }

  ngOnInit() {
    this._widgetNotifyService.onComponentDestroySubject.subscribe(isReady => {
      if (isReady) {
        this.mapViewReady = true;
      }
    });
  }

  public toggleSidebar() {
    this.toggleSidebarService.set(!this.toggleSidebarService.toggleSidebar);
  }

  get toggleSidebar$() {
    return this.toggleSidebarService.toggleSidebar$;
  }
  /**
   * @function showGoToWidget
   * @description Shows GO To widget to search X, Y Koordinates
   */
  public showGoToWidget() {
    this._mainMapService.closeWidgets();
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.GoToComponent);
  }

  /**
   * @function showUserWidget
   * @description Shows user widget when click on SBB user id
   */
  public showUserWidget() {
    this._mainMapService.closeWidgets();
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.UserComponent);
  }

  /**
   * @function setInitialExtent
   * @description Set initial extend when click on Home button
   */
  public setInitialExtent() {
    const initExtent = new EsriExtent(this._configService.mainMapConfig.extent);
    if (initExtent) {
      this._mainMapService.mapView.extent = initExtent;
    }
  }
}
